const servicesData = {
  "iphone-repair": {
    title: "iPhone Repair",
    slug: "iphone-repair",
    icon: "fab fa-apple",
    metaTitle: "iPhone Repair in Willow Grove, PA | Same-Day Fix | Cell Station",
    metaDescription:
      "Expert iPhone repair in Willow Grove, PA. Screen, battery, charging port, water damage & more for iPhone 6 through iPhone 16. Same-day service. Call (215) 939-3933.",
    heroText:
      "From iPhone 6 to the latest iPhone 16 — cracked screen, dead battery, or broken charging port? We fix them all, most same day, with a 30-day warranty.",
    description:
      "Cell Station is Willow Grove's trusted iPhone repair specialist. Our certified technicians fix every iPhone generation from iPhone 6 through the newest models — screen replacements, battery swaps, charging port repairs, water damage recovery, camera fixes, and more. Using premium OEM-compatible parts, we complete most iPhone repairs while you wait. Every repair is backed by a 30-day warranty for peace of mind.",
    features: [
      "iPhone 16 / 15 / 14 / 13 / 12 / 11 / X / 8 / 7 / 6 repairs",
      "Screen replacement (OLED & LCD)",
      "Battery replacement with health test",
      "Charging port / Lightning / USB-C repair",
      "Water damage diagnostic & recovery",
      "Rear camera & front camera repair",
      "Face ID & Touch ID troubleshooting",
      "Same-day service on most models",
    ],
    pricing: "Starting from $49",
    faqs: [
      {
        question: "How much does an iPhone screen repair cost?",
        answer:
          "iPhone screen repairs start at $49 for older models (iPhone 6/7/8) and range up to $249 for the latest iPhone 15/16 Pro Max OLED displays. We offer a free quote — call (215) 939-3933.",
      },
      {
        question: "Do you repair the latest iPhone models?",
        answer:
          "Yes! We repair all iPhone models including the latest iPhone 16 Pro Max. Most parts are in stock for same-day service.",
      },
      {
        question: "Will my Face ID still work after a repair?",
        answer:
          "In most cases, yes. We use quality parts that preserve Face ID functionality when available. We'll tell you upfront if a specific repair will affect biometrics.",
      },
      {
        question: "Do you offer a warranty on iPhone repairs?",
        answer:
          "Yes, every iPhone repair includes a 30-day warranty on parts and labor. If something isn't right, bring it back and we'll make it right.",
      },
    ],
  },

  "samsung-repair": {
    title: "Samsung Repair",
    slug: "samsung-repair",
    icon: "fab fa-android",
    metaTitle: "Samsung Galaxy Repair in Willow Grove, PA | Cell Station",
    metaDescription:
      "Samsung Galaxy repair near Willow Grove, PA. Galaxy S, Note, Z Fold & Z Flip screen, battery, charging port repairs. Same-day service. Call (215) 939-3933.",
    heroText:
      "Samsung Galaxy S, Note, Z Fold, or Z Flip — whatever the model, whatever the problem, our certified technicians can fix it.",
    description:
      "Samsung Galaxy phones have unique repair needs — from curved AMOLED displays to foldable screens. Cell Station has 19+ years of experience with Samsung devices: Galaxy S24, S23, S22, S21, Note, Z Fold, Z Flip, and older models. We handle everything from standard screen replacements to complex motherboard repairs. Same-day service available for most models, with a 30-day warranty on all repairs.",
    features: [
      "Galaxy S24 / S23 / S22 / S21 / S20 / S10 / S9 / S8",
      "Galaxy Note series repairs",
      "Galaxy Z Fold & Z Flip specialized service",
      "AMOLED screen replacement",
      "Battery replacement",
      "USB-C charging port repair",
      "Water damage recovery",
      "Camera module replacement",
    ],
    pricing: "Starting from $59",
    faqs: [
      {
        question: "Can you repair Samsung Z Fold or Z Flip screens?",
        answer:
          "Yes. Foldable phones require specialized tools and techniques — we're experienced with both Z Fold and Z Flip inner/outer screens and hinge assemblies.",
      },
      {
        question: "Do Samsung repairs cost more than iPhone repairs?",
        answer:
          "It depends on the model. Basic Galaxy repairs start at $59. Premium AMOLED screens on Note/Ultra models can be more expensive. We provide free quotes.",
      },
      {
        question: "How long does a Samsung screen repair take?",
        answer:
          "Most standard Galaxy screen repairs are completed in 45-90 minutes. Foldable phone repairs may take longer (same day or next day).",
      },
      {
        question: "Do you use genuine Samsung parts?",
        answer:
          "We use high-quality OEM-compatible parts. For premium models, we also offer genuine service parts when requested — ask about options when you bring your device in.",
      },
    ],
  },

  "ipad-repair": {
    title: "iPad Repair",
    slug: "ipad-repair",
    icon: "fas fa-tablet-alt",
    metaTitle: "iPad Repair in Willow Grove, PA | All Models | Cell Station",
    metaDescription:
      "iPad screen, battery & charging repair in Willow Grove, PA. iPad Pro, Air, Mini & standard — all generations. Same-day service. Call (215) 939-3933.",
    heroText:
      "iPad Pro, iPad Air, iPad Mini, or standard iPad — cracked screen or dead battery? We fix every iPad generation, fast.",
    description:
      "iPads take a beating from daily use and drops. Cell Station repairs every iPad model — iPad Pro 12.9\" and 11\", iPad Air, iPad Mini, and standard iPad. Common repairs include digitizer/glass replacement, LCD replacement, battery swaps, charging port fixes, and home button repairs. We work with the latest USB-C models as well as older Lightning-connector iPads.",
    features: [
      "iPad Pro (all generations) repairs",
      "iPad Air repairs",
      "iPad Mini repairs",
      "Standard iPad (all years) repairs",
      "Digitizer / front glass replacement",
      "LCD display replacement",
      "Battery replacement",
      "Home button & Touch ID repair",
    ],
    pricing: "Starting from $79",
    faqs: [
      {
        question: "How much does an iPad screen repair cost?",
        answer:
          "iPad screen repairs start at $79 for older models. iPad Pro 12.9\" repairs can be more expensive due to the large OLED/LCD display. We provide free quotes.",
      },
      {
        question: "Can you fix a shattered iPad screen?",
        answer:
          "Yes, shattered iPads are one of our most common repairs. We replace the digitizer/glass, and if the LCD underneath is damaged, we replace that too.",
      },
      {
        question: "How long does an iPad repair take?",
        answer:
          "Most iPad repairs take 1-3 hours. We may keep it overnight for thorough adhesive curing on some models to ensure longevity.",
      },
      {
        question: "Do you repair old iPads (pre-2018)?",
        answer:
          "Yes! We repair iPads going back to the iPad 2. Parts availability varies — give us a call and we'll check stock before you come in.",
      },
    ],
  },

  "screen-repair": {
    title: "Screen Repair",
    slug: "screen-repair",
    icon: "fas fa-mobile-alt",
    metaTitle: "Screen Repair in Willow Grove, PA | Cell Station",
    metaDescription:
      "Professional screen repair for iPhone, Samsung, iPad & more in Willow Grove, PA. Same-day service, quality parts, 30-day warranty. Call (215) 939-3933.",
    heroText:
      "Cracked, shattered, or unresponsive screen? We fix all makes and models with quality replacement parts and a 30-day warranty on every repair.",
    description:
      "A cracked screen doesn't just look bad — it can cause touch sensitivity issues, expose internal components to dust and moisture, and even cut your fingers. At Cell Station, our certified technicians replace screens using high-quality parts that restore your device to like-new condition. Most screen repairs are completed in under an hour while you wait.",
    features: [
      "iPhone screen replacement (all models)",
      "Samsung Galaxy screen replacement",
      "iPad & tablet screen repair",
      "OLED & LCD display replacement",
      "Touch digitizer repair",
      "Front glass replacement",
      "Same-day service available",
      "30-day warranty on all screen repairs",
    ],
    pricing: "Starting from $49",
    faqs: [
      {
        question: "How long does a screen repair take?",
        answer:
          "Most screen repairs are completed in 30-60 minutes. Some models may take slightly longer if parts need to be ordered.",
      },
      {
        question: "Do you use original parts?",
        answer:
          "We use high-quality OEM-compatible parts that match the original specifications of your device. We also offer premium OLED options for select models.",
      },
      {
        question: "Will I lose my data during a screen repair?",
        answer:
          "No. Screen repair does not affect your data, photos, or apps. Everything stays exactly as it was.",
      },
      {
        question: "Do you offer a warranty on screen repairs?",
        answer:
          "Yes! All screen repairs come with a 30-day warranty covering defects in parts and workmanship.",
      },
    ],
  },

  "battery-replacement": {
    title: "Battery Replacement",
    slug: "battery-replacement",
    icon: "fas fa-battery-full",
    metaTitle: "Battery Replacement in Willow Grove, PA | Cell Station",
    metaDescription:
      "Fast battery replacement for iPhone, Samsung, iPad, MacBook & laptops in Willow Grove, PA. Same-day service. Call (215) 939-3933 for a free quote.",
    heroText:
      "Is your phone dying too fast or not holding a charge? We replace batteries quickly so you can get back to full power.",
    description:
      "Over time, all rechargeable batteries degrade — your phone might drain faster, shut off unexpectedly, or even swell. A battery replacement is one of the most cost-effective ways to extend the life of your device by years. At Cell Station, we use premium replacement batteries and complete most swaps in under 30 minutes.",
    features: [
      "iPhone battery replacement (all models)",
      "Samsung Galaxy battery replacement",
      "iPad & tablet battery replacement",
      "MacBook & laptop battery replacement",
      "Battery health diagnostic testing",
      "Same-day service for most models",
      "30-day warranty included",
      "Eco-friendly old battery recycling",
    ],
    pricing: "Starting from $39",
    faqs: [
      {
        question: "How do I know if I need a new battery?",
        answer:
          "Common signs include rapid battery drain, unexpected shutdowns, the phone getting unusually hot, or a swollen/bulging battery. On iPhone, you can check Settings > Battery > Battery Health.",
      },
      {
        question: "How long does a battery replacement take?",
        answer:
          "Most battery replacements take 15-30 minutes. You can wait in-store or drop off and pick up later.",
      },
      {
        question: "Will a new battery make my phone faster?",
        answer:
          "Yes, in many cases. Older iPhones throttle performance when battery health is low. A new battery restores full processing speed.",
      },
      {
        question: "How long will the new battery last?",
        answer:
          "A quality replacement battery should last 2-3 years with normal use, similar to when your device was new.",
      },
    ],
  },

  "water-damage-repair": {
    title: "Water Damage Repair",
    slug: "water-damage-repair",
    icon: "fas fa-tint",
    metaTitle: "Water Damage Repair in Willow Grove, PA | Cell Station",
    metaDescription:
      "Expert water damage repair for phones, tablets & laptops in Willow Grove, PA. Fast diagnostic and recovery. Call (215) 939-3933 immediately.",
    heroText:
      "Dropped your phone in water? Don't panic — bring it to us as soon as possible. The faster we treat it, the better the chance of full recovery.",
    description:
      "Water damage is one of the most common and urgent phone emergencies. Whether your device took a swim in the pool, got caught in the rain, or had a drink spilled on it, time is critical. At Cell Station, we use professional ultrasonic cleaning equipment and thorough diagnostic testing to salvage water-damaged devices. We recommend bringing your device in as quickly as possible — do NOT try to charge it or turn it on.",
    features: [
      "Professional ultrasonic cleaning",
      "Corrosion removal and treatment",
      "Component-level diagnostic testing",
      "Circuit board repair",
      "Replacement of damaged components",
      "Data recovery from water-damaged devices",
      "Emergency same-day service",
      "Honest assessment — we'll tell you if it's fixable",
    ],
    pricing: "Diagnostic: Free | Repair from $59",
    faqs: [
      {
        question: "My phone got wet — what should I do right now?",
        answer:
          "Turn it off immediately. Do NOT try to charge it. Do NOT put it in rice (this is a myth and can cause more damage). Bring it to us as soon as possible.",
      },
      {
        question: "Can you fix a phone that was submerged in water?",
        answer:
          "In many cases, yes. Success depends on how long it was submerged, the type of liquid, and whether the phone was turned on while wet. We provide a free diagnostic to assess the damage.",
      },
      {
        question: "How long does water damage repair take?",
        answer:
          "The cleaning and drying process typically takes 24-48 hours to ensure all moisture is removed. Component replacement, if needed, may add additional time.",
      },
      {
        question: "Is water damage covered by warranty?",
        answer:
          "Most manufacturer warranties do not cover water damage. However, our repair work comes with a 30-day warranty on parts and labor.",
      },
    ],
  },

  "charging-port-repair": {
    title: "Charging Port Repair",
    slug: "charging-port-repair",
    icon: "fas fa-plug",
    metaTitle: "Charging Port Repair in Willow Grove, PA | Cell Station",
    metaDescription:
      "Charging port repair and replacement for iPhone, Samsung & more in Willow Grove, PA. Same-day fix. Call (215) 939-3933.",
    heroText:
      "Phone not charging? Loose connection? We repair and replace charging ports so your device powers up reliably every time.",
    description:
      "A faulty charging port is frustrating — your cable won't stay in, charging is intermittent, or your phone won't charge at all. Sometimes it's just lint and debris buildup that needs cleaning. Other times, the port itself needs replacement. At Cell Station, we diagnose the real issue and fix it right. Most charging port repairs are completed the same day.",
    features: [
      "Charging port cleaning (lint/debris removal)",
      "USB-C port replacement",
      "Lightning port replacement",
      "Micro-USB port repair",
      "Flex cable replacement",
      "Charging diagnostic testing",
      "Same-day service for most models",
      "30-day warranty on all repairs",
    ],
    pricing: "Cleaning: $19 | Replacement from $49",
    faqs: [
      {
        question: "How do I know if my charging port is broken?",
        answer:
          "Signs include: cable won't stay in, you have to hold the cable at an angle, charging is slow or intermittent, or the phone won't charge at all. Sometimes it's just debris — we'll check for free.",
      },
      {
        question: "Can you just clean the charging port?",
        answer:
          "Yes! Often the issue is just pocket lint or debris packed into the port. We carefully clean it with professional tools. If cleaning solves the problem, that's all you pay for.",
      },
      {
        question: "How long does a charging port replacement take?",
        answer:
          "Most charging port replacements take 30-60 minutes. Cleaning takes just a few minutes.",
      },
      {
        question:
          "Will replacing the charging port affect my water resistance?",
        answer:
          "We do our best to maintain the device's original sealing, but we recommend treating a repaired device with extra care around water.",
      },
    ],
  },

  "data-recovery": {
    title: "Data Recovery",
    slug: "data-recovery",
    icon: "fas fa-database",
    metaTitle: "Data Recovery in Willow Grove, PA | Cell Station",
    metaDescription:
      "Professional data recovery for phones, computers & hard drives in Willow Grove, PA. Recover photos, contacts & files. Call (215) 939-3933.",
    heroText:
      "Lost your photos, contacts, or important files? Our data recovery specialists can help retrieve your valuable data from damaged or malfunctioning devices.",
    description:
      "Losing data can be devastating — years of photos, important contacts, business documents, and irreplaceable memories. Whether your device is broken, water-damaged, virus-infected, or you accidentally deleted files, Cell Station's data recovery team has the tools and expertise to help. We work with phones, tablets, laptops, desktops, and external hard drives.",
    features: [
      "Phone data recovery (broken/damaged devices)",
      "Hard drive & SSD data recovery",
      "Photo and video recovery",
      "Contact and message recovery",
      "Virus/malware-infected device recovery",
      "Data transfer to new device",
      "Cloud backup setup assistance",
      "Confidential handling of all data",
    ],
    pricing: "Diagnostic: Free | Recovery from $69",
    faqs: [
      {
        question: "Can you recover data from a completely dead phone?",
        answer:
          "In many cases, yes. Even if the screen is shattered or the phone won't turn on, we can often access the storage chip directly to retrieve your data.",
      },
      {
        question: "How long does data recovery take?",
        answer:
          "Simple recoveries (data transfer, deleted file recovery) can often be done same-day. More complex cases involving damaged hardware may take 2-5 business days.",
      },
      {
        question: "Is my data kept confidential?",
        answer:
          "Absolutely. We treat all customer data with strict confidentiality. Our technicians follow professional privacy protocols and never access files beyond what's necessary for recovery.",
      },
      {
        question: "Can you recover data from a water-damaged device?",
        answer:
          "Yes, data recovery from water-damaged devices is one of our specialties. We clean and stabilize the device first, then extract the data.",
      },
    ],
  },

  "software-issues": {
    title: "Software & OS Issues",
    slug: "software-issues",
    icon: "fas fa-cog",
    metaTitle: "Software & OS Repair in Willow Grove, PA | Cell Station",
    metaDescription:
      "Fix software issues, virus removal, OS updates & more for phones and computers in Willow Grove, PA. Call (215) 939-3933.",
    heroText:
      "Phone frozen? Computer running slow? Virus infection? We diagnose and fix all software and operating system problems.",
    description:
      "Not all device problems are hardware-related. Slow performance, freezing, crashing apps, boot loops, virus infections, and failed updates are all software issues we handle daily. At Cell Station, we troubleshoot and resolve software problems on phones, tablets, laptops, and desktops. We also help with OS reinstallation, factory resets (with data backup), and setting up your device after a fix.",
    features: [
      "Virus and malware removal",
      "Operating system reinstallation",
      "Software update and upgrade assistance",
      "Boot loop and startup issue repair",
      "App crash troubleshooting",
      "Slow performance optimization",
      "Factory reset with data backup",
      "Spyware and adware removal",
    ],
    pricing: "Starting from $39",
    faqs: [
      {
        question: "My phone is stuck on the Apple/Samsung logo. Can you fix it?",
        answer:
          "Yes, this is called a boot loop and it's usually a software issue. We can often resolve it without losing your data. Bring it in and we'll diagnose it for free.",
      },
      {
        question: "Can you remove viruses from my computer?",
        answer:
          "Yes! We remove viruses, malware, spyware, and adware from both Windows and Mac computers. We also install protection to help prevent future infections.",
      },
      {
        question: "Will I lose my data if you reinstall my operating system?",
        answer:
          "We always attempt to back up your data before any OS reinstallation. In most cases, we can preserve your files, photos, and important documents.",
      },
      {
        question: "My computer is very slow. Can you speed it up?",
        answer:
          "Yes! We optimize startup programs, remove bloatware, clean temporary files, check for malware, and can upgrade hardware (RAM/SSD) if needed for a significant speed boost.",
      },
    ],
  },
};

export default servicesData;
